export const tipoHistoricoNome = (tipoHistorico) => {
  switch (tipoHistorico) {
    case 'COMPRA':
      return 'Compra';
    case 'MANUTENCAO':
      return 'Manutenção';
    case 'REPASSE':
      return 'Repasse';
    case 'VENDA_TROCA':
      return 'Venda/Troca';
    default:
      return tipoHistorico;
  }
};

export const ordernarPorDataHistorico = (a, b) =>
  b.dataHistorico.localeCompare(a.dataHistorico);

export const buildEquipamentoFilter = (filterData) => ({
  ...filterData,
  modelo: filterData.codigo,
});
